import {Sidebar} from '@/components/commons/sidebar/Sidebar'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ArrowLeftIcon, CurrencyDollarCircleIcon, MedicalCrossIcon, Users02Icon} from '@/components/ui/icon/Icon'
import {
    SidebarButtonLink,
    SidebarButtonNavLink,
    SidebarButtonsGroup,
    SidebarSeparator,
    SidebarSlot,
    SidebarTitleBar
} from '@/components/ui/sidebar-atoms/SidebarAtoms'
import {routes} from '@/utilities/constants/routes'
import {useTranslation} from '@/translations/i18n.tsx'
import {usePermissions} from '@/features/auth/store/store'

export const SettingsSidebar = () => {
    const {t} = useTranslation()
    const permissions = usePermissions()

    return (
        <Sidebar
            startSlot={
                <>
                    <SidebarSlot align="center" $fullHeight>
                        <SidebarTitleBar direction="column" fullWidth>
                            <SidebarButtonLink to={routes.DASHBOARD.path} size="lg">
                                <ArrowLeftIcon />
                                <span>{t('commons:settings')}</span>
                            </SidebarButtonLink>
                        </SidebarTitleBar>
                    </SidebarSlot>
                    <SidebarSeparator />
                </>
            }
            centerSlot={
                <Flexbox direction="column" gap={3} fullWidth>
                    <SidebarButtonsGroup>
                        {permissions?.settings?.read && (
                            <>
                                <SidebarButtonNavLink to={routes.USER_GROUPS_ROUTE.path}>
                                    <Users02Icon />
                                    {t('commons:user_groups')}
                                </SidebarButtonNavLink>
                                {/* <SidebarButtonNavLink to={routes.COMPANY_INFO_ROUTE.path}>
                                    <Building01Icon />
                                    {t('commons:company')}
                                </SidebarButtonNavLink> */}
                                <SidebarButtonNavLink to={routes.BUDGET_ROUTE.path}>
                                    <CurrencyDollarCircleIcon />
                                    {t('budget:title')}
                                </SidebarButtonNavLink>
                                <SidebarButtonNavLink to={routes.REFERRING_SPECIALIST.path}>
                                    <MedicalCrossIcon />
                                    {t('referring_specialist:title')}
                                </SidebarButtonNavLink>
                            </>
                        )}
                    </SidebarButtonsGroup>
                    <SidebarSeparator />
                </Flexbox>
            }
        />
    )
}

SettingsSidebar.displayName = 'SettingsSidebar'
